import type { UserFragment } from '@gql'
import { CaseReminderScope, Permission, UserRole } from '@gql'
import { hasPermission } from '@sections/auth/access'
import { CaseRemindersUrlScope } from '@sections/cases/urls'

export const REMINDER_SCOPE_BY_URL: Record<CaseRemindersUrlScope, CaseReminderScope> = {
  [CaseRemindersUrlScope.all]: CaseReminderScope.ALL,
  [CaseRemindersUrlScope.mine]: CaseReminderScope.MINE,
  [CaseRemindersUrlScope.team]: CaseReminderScope.TEAM,
}

/** Whether the user works cases of their own: only they have a MINE queue to be told about. */
export const hasOwnReminders = (user: UserFragment | null | undefined): boolean =>
  Boolean(user?.roles.some((role) => role === UserRole.OPERATOR || role === UserRole.TEAMLEADER))

/**
 * The Reminders tabs this user may open, in display order. Mirrors crm-core's
 * scope rules: Team needs the team-lead role, All needs MANAGE_CASES (and is
 * the only one that shows unassigned cases).
 */
export const reminderScopesFor = (
  user: UserFragment | null | undefined,
): CaseRemindersUrlScope[] => {
  const scopes: CaseRemindersUrlScope[] = []
  if (hasOwnReminders(user)) {
    scopes.push(CaseRemindersUrlScope.mine)
  }

  if (user?.roles.includes(UserRole.TEAMLEADER)) {
    scopes.push(CaseRemindersUrlScope.team)
  }

  if (hasPermission(Permission.MANAGE_CASES, user)) {
    scopes.push(CaseRemindersUrlScope.all)
  }

  return scopes
}
